module.exports = __webpack_public_path__ + "static/media/archive-sync-outline.bbeb6507.svg";